import Http from "@/utils/request.js";

//app版本更新
export function AppCheckUpdate(platform){
	return Http.request({
		url: `/user/package/getLatestVersion`,
		method: 'post',
		data:{
			platform
		}
	})
}

